<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toDepositManagement">返回</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账单主体：</span>
        </div>
        <el-input v-model="formData.payer" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联账单：</span>
        </div>
        <el-select v-model="payItemDetailListChoose" multiple placeholder="请选择" size="small" style="width: 280px" disabled>
          <el-option
            v-for="item in payItemDetailList"
            :key="item.code"
            :label="item._label"
            :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款金额：</span>
        </div>
        <el-input v-model="formData.money" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款方式：</span>
        </div>
        <el-select v-model="formData.payChannel" placeholder="请选择" size="small" style="width: 280px" disabled>
          <el-option
            v-for="item in payChannelModifyList"
            :key="item.key"
            :label="item.label"
            :value="item.key">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收款日期：</span>
        </div>
        <el-date-picker v-model="formData.payTime" type="datetime" size="small" style="width: 280px" :editable=false value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" disabled></el-date-picker>
      </div>

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">发票状态：</span>-->
<!--        </div>-->
<!--        <el-select v-model="formData.invoiceStatus" placeholder="请选择" size="small" style="width: 280px" disabled>-->
<!--          <el-option-->
<!--            v-for="item in invoiceStatusModifyList"-->
<!--            :key="item.key"-->
<!--            :label="item.label"-->
<!--            :value="item.key">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->

<!--      <div class="form-line" v-if="formData.invoiceStatus === '1'">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">开票日期：</span>-->
<!--        </div>-->
<!--        <el-date-picker-->
<!--          disabled-->
<!--          v-model="formData.invoiceTime"-->
<!--          type="date"-->
<!--          size="small"-->
<!--          style="width: 280px"-->
<!--          :editable=false-->
<!--          value-format="yyyy-MM-dd"-->
<!--          placeholder="选择日期">-->
<!--        </el-date-picker>-->
<!--      </div>-->

      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" disabled/>
      </div>

    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/Finance'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'

  export default {
    components: {
      ButtonConfirmNext,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'contract-pay-record-current',
    data () {
      return {
        breadcrumb: [{
          value: '智慧财务',
          name: 'finance-over-view'
        }, {
          value: '收款管理'
        }],
        mainTitle: '查看收款记录',
        subheading: '',
        payChannelModifyList: [{
          key: '1',
          label: '微信'
        }, {
          key: '2',
          label: '支付宝'
        }, {
          key: '3',
          label: '银行转账'
        }, {
          key: '4',
          label: '现金'
        }, {
          key: '5',
          label: '其他'
        }],

        invoiceStatusModifyList: [{
          key: '0',
          label: '未开票'
        }, {
          key: '1',
          label: '已开票'
        }],

        enterpriseLoading: false,
        enterpriseList: [],

        payItemDetailList: [],
        payItemDetailListChoose: [],

        formData: {
          bills: [],
          enterpriseCode: '',
          enterpriseName: '',
          money: '',
          payChannel: '',
          payTime: '',
          invoiceStatus: '0',
          invoiceTime: '',
          memo: '',
        }
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getLeasePaymentRecordByCode()
    },
    methods: {
      getLeasePaymentRecordByCode () {
        this.$axios.get(`${api.getReceivePaymentByCode}/${this.currentCode}`, {})
          .then(res => {
            let data = res.data.data
            this.formData = data
            let bills = data.bills || []
            let payItemDetailListChoose = []
            bills.map(bill => {
              bill.code = bill.billNo
              if (bill.memo) {
                bill._label = `${bill.paymentItemName}/${bill.money}元/${bill.memo}`
              } else {
                bill._label = `${bill.paymentItemName}/${bill.money}元`
              }

              payItemDetailListChoose.push(bill.billNo)
            })
            this.payItemDetailListChoose = payItemDetailListChoose
            this.payItemDetailList = bills
            // this.getPayItemDetailListByCondition()
          })
          .catch(errorHandler('获取数据失败'))
      },

      toDepositManagement () {
        this.$router.push({
          name: 'contract-pay-record'
        })
      },

      // 获取账单列表
      getPayItemDetailListByCondition () {
        this.$axios.post(`${api.getTotalBillList}`, {
          payer: this.formData.payer,
          status: '0',
        })
          .then(res => {
            let data = res.data.data
            let payItemDetailListChoose = []
            data.map(v => {
              v._label = `${v.feeType}/${v.payDeadline}/${v.payMoney}元`
            })
            data.push({
              code: 'other',
              _label: '其他',
              billNo: 'other'
            })
            data.map(v => {
              this.formData.bills.map(bill => {
                if (v.code === bill.billNo) {
                  payItemDetailListChoose.push(v.code)
                }
              })
            })
            this.payItemDetailListChoose = payItemDetailListChoose
            this.payItemDetailList = data
          })
          .catch(errorHandler('查询账单失败'))
      },
      confirm () {
        if (!this.formData.enterpriseCode) {
          nError('请选择住户名称')
          return
        }
        if (this.formData.bills.length === 0) {
          nError('请选择关联账单')
          return
        }
        if (!this.formData.money) {
          nError('请输入收款金额')
          return
        }
        if (!this.formData.payChannel) {
          nError('请选择收款方式')
          return
        }
        if (this.formData.invoiceStatus === '1' && !this.formData.invoiceTime) {
          nError('请输入开票日期')
          return
        }
        this.$axios.post(api.addLeasePaymentRecord, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toDepositManagement()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toDepositManagement()
      }
    },
    watch: {
      payItemDetailListChoose (v) {
        let bills = []
        this.payItemDetailListChoose.map(v => {
          this.payItemDetailList.map(payItem => {
            if (payItem.code === v) {
              let obj = {
                billNo: payItem.code
              }
              bills.push(obj)
            }
          })
        })
        this.formData.bills = bills
      }
    }
  }
</script>

<style scoped>
.flexBox {
  display: flex;
  justify-content: space-between;
}
.header-btn-box {
  margin: 20px 0 10px 0;
  color: #337ab7;
  font-size: 14px;
}
.header-btn-box a{
  margin-right: 40px;
  cursor: pointer;
}
.header-btn-box a:hover{
  color: #00a0e6;
}
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 180px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px 0;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Finance/InvestmentFinance/contractPayRecordCurrent.vue